/* BACFREE Customer Trust: review carousel arrows + click-to-enlarge lightbox */
if (!customElements.get('bct-reviews')) {
  class BctReviews extends HTMLElement {
    connectedCallback() {
      this.ctrl = new AbortController();
      const opt = { signal: this.ctrl.signal };
      this.track = this.querySelector('[data-bct-track]');
      this.prev = this.querySelector('[data-bct-prev]');
      this.next = this.querySelector('[data-bct-next]');
      this.dialog = this.querySelector('dialog');
      this.lbImg = this.dialog ? this.dialog.querySelector('img') : null;
      this.items = Array.from(this.querySelectorAll('[data-bct-full]'));
      this.current = 0;
      if (!this.track) return;

      const step = () => {
        const card = this.track.querySelector('.bct__card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
      };
      const update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      };
      this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step() }), opt);
      this.next?.addEventListener('click', () => this.track.scrollBy({ left: step() }), opt);
      this.track.addEventListener('scroll', update, { ...opt, passive: true });
      window.addEventListener('resize', update, opt);
      update();

      if (!this.dialog || !this.lbImg || !this.items.length) return;
      this.dialog.classList.toggle('bct__lightbox--single', this.items.length < 2);
      this.items.forEach((btn, i) => btn.addEventListener('click', () => this.open(i), opt));
      this.dialog.querySelector('[data-bct-close]')?.addEventListener('click', () => this.dialog.close(), opt);
      this.dialog.querySelector('[data-bct-lb-prev]')?.addEventListener('click', () => this.show(this.current - 1), opt);
      this.dialog.querySelector('[data-bct-lb-next]')?.addEventListener('click', () => this.show(this.current + 1), opt);
      this.dialog.addEventListener('click', (e) => { if (e.target === this.dialog) this.dialog.close(); }, opt);
      this.dialog.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.show(this.current - 1);
        if (e.key === 'ArrowRight') this.show(this.current + 1);
      }, opt);
      this.dialog.addEventListener('close', () => { document.documentElement.style.overflow = ''; }, opt);
    }
    show(i) {
      const n = this.items.length;
      this.current = (i + n) % n;
      const btn = this.items[this.current];
      this.lbImg.src = btn.dataset.bctFull;
      this.lbImg.alt = btn.dataset.bctAlt || '';
    }
    open(i) {
      this.show(i);
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }
    disconnectedCallback() {
      this.ctrl?.abort();
      document.documentElement.style.overflow = '';
    }
  }
  customElements.define('bct-reviews', BctReviews);
}